import React, { useEffect, useState } from "react";
import "./css/Footer.css"; // Import your custom CSS
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import ff from "./images/homepage (31).webp"; // Import logo image
import logo from "./images/IMG (73).webp";

import f1 from "./images/Phone icon pbt.webp";
import f2 from "./images/IMG (56).webp";
import f3 from "./images/IMG (57).webp";
import f4 from "./images/IMG (58).webp";
import { addSubscriber } from "../App/Slices/newsletterSlice";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { useLocation } from "react-router-dom";
import {
  BsFacebook,
  BsInstagram,
  BsLinkedin,
  BsWhatsapp,
  BsYoutube,
} from "react-icons/bs";

const Footer = () => {
  const dispatch = useDispatch();
  const [formData, setFormData] = useState({
    name: "",
    email: "",
  });
  const handleScrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubscribe = (e) => {
    e.preventDefault();

    if (!formData.name || !formData.email) {
      toast.error("Please fill in all fields!");
      return;
    }

    dispatch(addSubscriber(formData));
    toast.success("Subscribed successfully 🎉");

    // Reset fields
    setFormData({
      name: "",
      email: "",
    });
  };

  // Menu items array
  const menuItems = [
    { name: "Home", link: "/" },
    { name: "Our Company", link: "/our-company" },
    { name: "Products", link: "/products" },
    { name: "Blogs", link: "/blogs" },
    { name: "Events", link: "/events" },
    { name: "Contact Us", link: "/contact" },
    { name: "Research & Innovation", link: "/research-and-innovation" },
  ];

  return (
    <footer className="footer bg-white">
      <Container fluid className="">
        {/* Newsletter Section */}
        <Row className="newsletter-section d-flex justify-content-center align-items-center">
          <Col md={4} className="text-center text-md-start">
            <h5 className="newsletter-title">
              SUBSCRIBE TO OUR <strong>NEWSLETTER</strong>
            </h5>
          </Col>
          <Col md={8} lg={8} className="newsletter">
            <Form className="d-flex flex-wrap gap-2" onSubmit={handleSubscribe}>
              <Form.Control
                type="text"
                name="name"
                placeholder="Enter your name"
                className="flex-grow-1 bg-white"
                value={formData.name}
                onChange={handleChange}
              />
              <Form.Control
                type="email"
                name="email"
                placeholder="Enter your email"
                className="flex-grow-1"
                value={formData.email}
                onChange={handleChange}
              />
              <Button type="submit" variant="primary">
                SUBSCRIBE
              </Button>
            </Form>
          </Col>
        </Row>

        {/* Main Footer Content - 3 Sections */}
        <Row className="footer-main-content">
          {/* Section 1: Logo and Images */}
          <Col
            lg={4}
            md={12}
            className="footer-section logo-section flex-column align-items-center"
          >
            <div className="logo-container">
              <div className="logo">
                <img
                  src={ff}
                  alt="Panav Bio-Tech Logo"
                  className="logo-img footer-logo-img"
                  loading="lazy"
                />
              </div>
              <div className="brand-logo">
                <img
                  src={logo}
                  className="imglogo-footer"
                  alt="Brand Logo"
                  loading="lazy"
                />
              </div>
            </div>
            <button
              className="btn  visit-btn mt-3"
              onClick={handleScrollToTop}
            ></button>
          </Col>

          {/* Section 2: Contact Information */}
          <Col lg={4} md={6} className="footer-section contact-section">
            <h5 className="section-title">CONTACT INFO</h5>

            {/* Contact Details */}
            <div className="contact-item">
              <div className="contact-icon">
                <img
                  src={f1}
                  className="contact-icon-img"
                  alt="Phone"
                  loading="lazy"
                />
              </div>
              <div className="contact-info">
                <p>
                  <strong>CONTACT US</strong>
                </p>
                <p className="contact-text">
                  <a href="tel:+911147563428" className="contact-link">
                    011-47563428
                  </a>
                  ,{" "}
                  <a href="tel:+911147563626" className="contact-link">
                    011-47563626
                  </a>
                  <br />
                  Customer care –{" "}
                  <a href="tel:+9118005721434" className="contact-link">
                    1800 572 1434
                  </a>
                </p>
              </div>
            </div>

            <div className="contact-item">
              <div className="contact-icon">
                <img
                  src={f2}
                  className="contact-icon-img"
                  alt="Hours"
                  loading="lazy"
                />
              </div>
              <div className="contact-info">
                <p>
                  <strong>WORKING HOURS</strong>
                </p>
                <ul className="contact-hours">
                  <li>Open from 10:30am - 7:00pm</li>
                  <li>Monday to Saturday: Open</li>
                  <li>Sunday: Closed</li>
                </ul>
              </div>
            </div>

            <div className="contact-item">
              <div className="contact-icon">
                <img
                  src={f3}
                  className="contact-icon-img"
                  alt="Location"
                  loading="lazy"
                />
              </div>
              <div className="contact-info">
                <p className="contact-text">
                  <a
                    href="https://www.google.com/maps/search/?api=1&query=70+Rama+Road+B-6+Najafgarh+Road+Industrial+Area+New+Delhi+Delhi+110015"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="contact-link"
                  >
                    70, Rama Road, B-6, Najafgarh Road
                    <br />
                    Industrial Area, New Delhi, Delhi 110015
                  </a>
                </p>
              </div>
            </div>

            <div className="contact-item">
              <div className="contact-icon">
                <img
                  src={f4}
                  className="contact-icon-img"
                  alt="Email"
                  loading="lazy"
                />
              </div>
              <div className="contact-info">
                <p className="contact-text">
                  <a
                    href="mailto:info@panavbiotech.com"
                    className="contact-link"
                  >
                    info@panavbiotech.com
                  </a>
                </p>
              </div>
            </div>
          </Col>

          {/* Section 3: Menu Items */}
          <Col lg={4} md={6} className="footer-section menu-section">
            <h5 className="section-title">QUICK LINKS</h5>
            <ul className="footer-menu">
              {menuItems.map((item, index) => (
                <li key={index} className="menu-item">
                  <a href={item.link} className="menu-link">
                    {item.name}
                  </a>
                </li>
              ))}
            </ul>

            {/* Social Media or Additional Info can go here */}
            <div className="additional-info">
              <h6 className="info-title">Follow Us</h6>
              <div className="social-media-links">
                <a
                  href="https://www.facebook.com/panavbiotech/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="social-icon facebook"
                >
                  <BsFacebook className="w-5 h-5" />
                </a>
                <a
                  href="https://www.instagram.com/panavbiotech/?hl=en"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="social-icon instagram"
                >
                  <BsInstagram className="w-5 h-5" />
                </a>
                <a
                  href="https://www.linkedin.com/company/panavbiotech/posts/?feedView=all"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="social-icon linkedin"
                >
                  <BsLinkedin className="w-5 h-5" />
                </a>
                <a
                  href="https://wa.me/919625404365"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="social-icon whatsapp"
                >
                  <BsWhatsapp className="w-5 h-5" />
                </a>
                <a
                  href="https://youtube.com/@panavbio-tech?si=OCdvkZ5J_yA6y1z7"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="social-icon youtube"
                >
                  <BsYoutube className="w-5 h-5" />
                </a>
              </div>
            </div>
          </Col>
        </Row>
        {/* Scroll to Top Button */}
        <Row className="scroll-to-top-section">
          <Col className="text-center">
            <button
              className={`scroll-to-top-btn btn show`}
              onClick={handleScrollToTop}
              aria-label="Scroll to top"
            >
              {/* <FaChevronUp /> */}
              <span>Back to Top</span>
            </button>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;
